<template>
  <div>
    <i-form label-position="top">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center">
          <h2>Modo Debug [{{id_empresa}}]</h2>
        </vs-col>
        <i-col>
          <form-item label="Desativar/Ativar">
            <i-switch size="large" v-model="debug">
              <Icon slot="open" type="md-checkmark"></Icon>
              <Icon slot="close" type="md-close"></Icon>
            </i-switch>
          </form-item>
        </i-col>
      </vs-row>
    </i-form>
    <div class="floating-btn">
      <i-button v-if="show_button" @click="onSave" icon="md-checkmark" shape="circle" type="primary"></i-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id_empresa: Number,
    show_save: Boolean
  },
  data: () => ({
    debug: false,
    show_button: true
  }),
  methods: {
    async onSave() {
      const data = await this.$axios.post(
        "clientes/setDebug",
        {
          id: this.$props.id_empresa,
          debug: this.debug
        }
      );
      const response = data.data;
      if (response["result"] == "success") {
        this.$Message.success("Modo Debug atualizado com sucesso!");
      } else {
        this.$Message.error("Oops, aconteceu um erro. Tente novamente.");
        this.debug = !this.debug;
      }
    },
    async getDebug() {
      let response = await this.$axios.get("clientes/getDebug", {
        params: {
          id: this.$props.id_empresa
          
        }
      });
      if (response.data.value == null) {
        this.$Message.error("Erro ao recuperar os dados da empresa.");
        this.show_button = false;
      } else {
        if (response.data.value == 1) {
          this.debug = true;
        } else {
          this.debug = false;
        }
      }
    },
    onChange() {
      this.$emit("change");
      this.show_button = true;
    }
  },
  created() {
    this.getDebug();
  }
};
</script>

<style lang="scss" scoped>
h2 {
  margin-bottom: 20px;
}
.ivu-form-item {
  width: 100%;
  margin: 10px;
}
.ivu-collapse {
  width: 100%;
}
.ivu-date-picker {
  width: 100%;
}
.ivu-tooltip {
  width: 100%;
}
</style>